export default "__VITE_ASSET__a2114393__"